<template>
  <div>
    <mt-tab-container v-model="currentTab">
      <mt-tab-container-item id="prod">
        <ProdList></ProdList>
      </mt-tab-container-item>
      <mt-tab-container-item id="sales">
        <EntSales></EntSales>
      </mt-tab-container-item>
      <mt-tab-container-item id="profile">
        <Profile></Profile>
      </mt-tab-container-item>
    </mt-tab-container>
    <mt-tabbar v-model="currentTab" :fixed="true">
      <mt-tab-item id="prod" href="#/index/prod">
        <svg slot="icon" t="1579574452466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="813" width="20" height="20"><path d="M879.905 670.22l29.583 52.245-338.9 190.809c-35.71 20.105-79.346 20.21-115.152 0.275L113.592 723.23l29.331-52.385 341.845 190.319a57.577 57.577 0 0 0 56.236-0.135l338.9-190.808z m0-179.99l29.583 52.244-338.9 190.809c-35.71 20.105-79.346 20.21-115.152 0.275L113.592 543.239l29.331-52.385 341.845 190.319a57.577 57.577 0 0 0 56.236-0.135l338.9-190.808z m-325.13-380.792l343.08 191.66c21.085 11.779 28.601 38.37 16.789 59.394a43.697 43.697 0 0 1-16.788 16.74l-343.08 191.66a87.736 87.736 0 0 1-85.551 0l-343.08-191.66c-21.085-11.778-28.601-38.37-16.789-59.393a43.697 43.697 0 0 1 16.788-16.74l343.08-191.661a87.736 87.736 0 0 1 85.551 0z m-56.142 52.342L181.106 339.165 498.633 516.55a27.417 27.417 0 0 0 26.734 0l317.527-177.385L525.367 161.78a27.417 27.417 0 0 0-26.734 0z" fill="#8a8a8a" p-id="814"></path></svg>
        产品管理
      </mt-tab-item>
      <mt-tab-item id="sales" href="#/index/sales">
        <svg slot="icon" t="1579574480126" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1029" width="20" height="20"><path d="M849.237 136.533c48.26 0 87.382 39.193 87.382 87.54v456.85c0 48.346-39.122 87.54-87.382 87.54l-307.2-0.002v61.553h247.126v60.183H234.837v-60.183h247.126V768.46l-307.2 0.001c-48.26 0-87.382-39.193-87.382-87.54V224.073c0-48.347 39.122-87.54 87.382-87.54h674.474z m0 60.184H174.763c-15.081 0-27.307 12.248-27.307 27.356v456.85c0 15.108 12.226 27.355 27.307 27.355h674.474c15.081 0 27.307-12.247 27.307-27.356V224.073c0-15.108-12.226-27.356-27.307-27.356zM716.8 349.525l42.48 42.557L645.875 505.69c-37.324 37.392-97.837 37.392-135.16 0l-52.727-52.821c-13.863-13.889-36.34-13.889-50.203 0l-103.163 103.35-42.479-42.556 103.163-103.35c37.324-37.392 97.837-37.392 135.161 0l52.726 52.821c13.863 13.888 36.34 13.888 50.203 0L716.8 349.525z" fill="#8a8a8a" p-id="1030"></path></svg>
        销售管理
      </mt-tab-item>
      <mt-tab-item id="profile" href="#/index/profile">
        <svg slot="icon" t="1579574500796" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1245" width="20" height="20"><path d="M512 519.333c-75.982 0.005-146.194-40.528-184.186-106.33-37.992-65.8-37.992-146.872 0-212.674C365.806 134.53 436.018 93.995 512 94c117.447 0.007 212.653 95.22 212.653 212.667S629.447 519.326 512 519.333z m0-58.666c55.019 0 105.858-29.353 133.368-77 27.51-47.648 27.51-106.353 0-154-27.51-47.648-78.35-77-133.368-77-85.052 0-154 68.948-154 154s68.948 154 154 154zM365.333 622c-68.851 0-124.666 55.815-124.666 124.667v110c0 8.066 6.6 14.666 14.666 14.666h513.334c8.1 0 14.666-6.566 14.666-14.666v-110c0-68.852-55.815-124.667-124.666-124.667H365.333z m0-58.667h293.334A183.333 183.333 0 0 1 842 746.667v110c0 40.5-32.832 73.333-73.333 73.333H255.333c-40.5 0-73.333-32.832-73.333-73.333v-110a183.333 183.333 0 0 1 183.333-183.334z" fill="#8a8a8a" p-id="1246"></path></svg>
        我的
      </mt-tab-item>
    </mt-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import ProdList from "@/components/ProdList";
import Profile from "@/components/Profile";
import EntSales from "@/components/EntSales";
import {
  Tabbar,
  TabItem,
  TabContainer,
  TabContainerItem,
  MessageBox
} from "mint-ui";

Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
Vue.component(TabContainer.name, TabContainer);
Vue.component(TabContainerItem.name, TabContainerItem);
Vue.component(MessageBox.name, MessageBox);

export default {
  components: {ProdList,Profile,EntSales},
  name: "index",
  data() {
    return {
      currentTab: "prod"
    };
  },
  mounted() {
    if (this.$route.params.view) {
      this.currentTab = this.$route.params.view;
    }
  }
};
</script>
<style scoped>
body {
  background: #ffffff;
}
a.mint-tab-item {
  color: #333333;
}
.mint-tabbar{
  position: fixed;
}
</style>